module.exports = __webpack_public_path__ + "media/images/icon_login_01-e8c4ba146ac59b6059a8f95e3e999850.svg";